import { memo, useRef } from 'react';

import { NavItem } from '@/types/whoami';

import useWxNavbar from './use-wx-navbar';

export type WxNavbarHostProps = {
  userId?: string;
  locale?: string;
  companyId?: string;
  inboxCount?: number;
  employerDomain?: string;
  employerBasePath?: string;
  disableNavigation?: boolean;
  mainConfig?: NavItem[];
  secondaryConfig?: NavItem[];
  dropdownConfig?: NavItem[];
  /** Host SPA path so the UMD can resolve active nav (not in the same React root as the router). */
  hostPathname: string;
};

/**
 * Wraps the wx-navbar UMD bundle. Memoized so unrelated parent re-renders that
 * pass referentially-stable props skip straight through (the new UMD applies
 * subsequent `render()` calls in place, so we want to avoid unnecessary calls
 * but tolerate the ones that do come through).
 *
 * `hostPathname` must be the host SPA's current path (typically
 * `useLocation().pathname`) so the navbar can resolve active state without
 * sharing a router context with the host.
 */
function WxNavbarHost(props: WxNavbarHostProps) {
  const ref = useRef<HTMLDivElement>(null);

  // forward all props 1:1 to the UMD render via the hook
  useWxNavbar({ mountRef: ref, renderProps: props });

  return <div id="wx-navbar-root" ref={ref} />;
}

export default memo(WxNavbarHost);
